module.exports = __webpack_public_path__ + "img/line-top.ea10694e.svg";